import React from 'react';

import { Entity } from '~/eds/src/types/Entity';
import { useCommentPdfHighlights } from '~/hooks/useCommentPdfHighlights';
import { Comment, ContextEntityType } from '~/types/Comment';
import {
  CreateCommentHighlightParams,
  HighlightEntityType,
} from '~/types/Highlight';
import { Nullable } from '~/types/Nullable';
import { Uuid } from '~/types/Uuid';

interface ChildrenParams {
  activeCommentId: Nullable<string>;
  activeHighlightId: Nullable<string>;
  documentVersionHighlights?: any[];
  onUpdateFilters: (filteredComments: Comment[]) => void;
  highlightResolver: (
    highlightEntity: Entity,
  ) => Nullable<{ id: Uuid; text: string }>;
  onCreateComment: (
    param: CreateCommentHighlightParams,
  ) => Promise<Nullable<Comment>>;
  setActiveCommentId: (commentId: string) => void;
  setActiveHighlight: (highlightId: string) => void;
  setIsDocumentLoading: (isLoading: boolean) => void;
}

interface Props {
  entity: Entity;
  render: (params: ChildrenParams) => React.ReactNode;
  context: Entity<ContextEntityType>[];
  highlightEntity: HighlightEntityType;
  activeCommentId?: string;
}

export default function CommentHighlightRenderProps({
  activeCommentId: initialActiveCommentId,
  context,
  entity,
  highlightEntity,
  render,
}: Props) {
  const {
    activeCommentId,
    activeHighlightId,
    highlights,
    onUpdateFilters,
    highlightResolver,
    onCreateComment,
    setActiveCommentId,
    setActiveHighlight,
    setIsDocumentLoading,
  } = useCommentPdfHighlights({
    activeCommentId: initialActiveCommentId,
    context,
    entity,
    highlightEntity,
  });

  return render({
    activeCommentId,
    activeHighlightId,
    documentVersionHighlights: highlights,
    onUpdateFilters,
    highlightResolver,
    onCreateComment,
    setActiveCommentId,
    setActiveHighlight,
    setIsDocumentLoading,
  });
}
